import { useChuckClientContext, useAPI } from '@gopeerproject/chuck'
import { useMutation, useQueryClient } from 'react-query'
import { useClassroomState } from './useClassroom'

export const useClassroomUpdate = (options) => {
  const { id } = useClassroomState()
  const { patch } = useAPI()
  const { client } = useChuckClientContext()
  const queryClient = useQueryClient()

  return useMutation(
    (body) =>
      patch({ url: `/appointments/${id}`, data: body }).then((res) => res.data),
    {
      onSuccess: ({
        overtime,
        rating,
        review,
        duration,
        participants,
        id,
        standard
      }) => {
        queryClient.setQueryData(['classrooms', id], (prevClassroom) => ({
          ...prevClassroom,
          overtime,
          rating,
          review,
          duration,
          participants: participants.reduce(
            (acc, participant) => ({
              ...acc,
              [participant.id]: {
                name: participant.name,
                image: participant.image,
                type: participant.type
              }
            }),
            {}
          ),
          standard
        }))
      },
      onError: (err) => {
        client.captureException(err)
      },
      ...options
    }
  )
}
